<app-global-loading *ngIf="loading"></app-global-loading>
<div class="content" [formGroup]="formGroup">
  <div class="top">
    <div class="top1">
      <span class="name">
        #{{ logs[0]?.workorder?.bus_seat?.bus_id }}
        {{ logs[0]?.workorder?.problem_platform?.problem }}
      </span>

      <span
        *ngIf="workorderStatus"
        class="status"
        [ngClass]="workorderStatus.class"
      >
        {{ workorderStatus.text }}
      </span>
    </div>
    <app-special-workorder-panel
      *ngIf="isHoliday()"
    ></app-special-workorder-panel>
    <div class="top2">
      <span>{{ logs[0]?.workorder?.bus_seat?.bus?.platform.name }}</span
      ><span>&nbsp;-&nbsp;</span
      ><span>
        <ng-container
          *ngIf="
            logs[0]?.workorder.bus_seat?.bus?.platform.name !==
              'ChatGPT镜像版' &&
            logs[0]?.workorder.bus_seat?.bus?.platform.name !== '爆米花' &&
            logs[0]?.workorder.bus_seat?.bus?.platform.name !==
              'Midjourney镜像版' &&
            logs[0]?.workorder.bus_seat?.bus?.platform.name !== 'Grok镜像版'
          "
          >{{
            logs[0]?.workorder.bus_seat?.bus?.bus_account?.username
          }}</ng-container
        >
      </span>
    </div>
  </div>
  <div class="logs">
    <ng-container *ngFor="let item of logs">
      <div class="item right" *ngIf="item.sender === 'User'">
        <div class="detail">
          <div class="name">
            <app-datetime [text]="item.created_time"></app-datetime>
            {{ item.workorder.user.nickname }}
          </div>
          <div class="qa">
            <div class="text" *ngIf="item.sender === 'User'">
              <p>{{ item.message }}</p>
            </div>

            <div class="imgs">
              <app-image
                *ngFor="let img of item.images"
                [fileid]="img"
                width="100px"
                height="100px"
                (click)="preview(img)"
              >
              </app-image>
            </div>
          </div>
        </div>
        <div class="avatar">
          <app-user-avatar [fileid]="item.workorder.user.avatar" size="40px">
          </app-user-avatar>
        </div>
      </div>
      <div class="item left" *ngIf="item.sender === 'CustomerService'">
        <div class="avatar">
          <img src="../../../../../assets/images/workorder/logo.webp" alt="" />
        </div>
        <div class="detail">
          <div class="name">
            环球巴士
            <app-datetime [text]="item.created_time"></app-datetime>
          </div>
          <div class="qa">
            <div
              class="text"
              #textRef
              [innerHTML]="item.message"
              *ngIf="item.sender === 'CustomerService'"
            ></div>
            <div class="imgs">
              <app-image
                *ngFor="let img of item.images"
                [fileid]="img"
                width="100px"
                height="100px"
                (click)="preview(img)"
              >
              </app-image>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="tips" *ngIf="showTips">
    <img src="../../../../../assets/images/workorder/bell.png" alt="" />
    5月1日至5月3日网站值班客服人员较少，回复不及时还请见谅。祝大家五一快乐！
  </div>

  <ng-container *ngIf="logs[0]?.workorder.status">
    <div class="bottom">
      <!-- <ng-container
        *ngIf="
          logs[0]?.workorder.status === 'Processing' ||
          logs[0]?.workorder.status === 'Supplemented' ||
          logs[0]?.workorder.status === 'ProcessCompleted' ||
          logs[0]?.workorder.status === 'Completed'
        "
      >
        <app-workorder-progress-panel
          [progress]="logs[0]?.workorder.status"
          [logs]="logs"
        ></app-workorder-progress-panel>
      </ng-container>
      <ng-container
        *ngIf="
          logs[0]?.workorder.status === 'NeedToSupplement' ||
          logs[0]?.workorder.status === 'ReplyReceived' ||
          logs[0]?.workorder.status === 'NoResponseReceived' ||
          logs[0]?.workorder.status === 'ProactiveCompletion' ||
          logs[0]?.workorder.status === 'PassiveCompletion' ||
          logs[0]?.workorder.status === 'CustomerServiceCompletion'
        "
      > -->
      <app-input-panel
        [value]="formGroup.value"
        (valueChange)="onInputChange($event)"
      ></app-input-panel>
      <div class="tip">
        <img
          src="../../../../../assets/images/workorder/Icon-exclamation-point.svg"
          alt=""
          [width]="14"
          [height]="14"
        />
        注：若您的问题已解决，可以点击“评价”。工单将会在<span>24小时</span>无回复后自动关闭，感谢支持与理解
      </div>
      <div class="button">
        <button
          class="button1"
          matRipple
          (click)="close()"
          [disabled]="
            loading || logs[0]?.workorder?.eval_status === 'evaluated'
          "
          [ngStyle]="{
            cursor:
              loading || logs[0]?.workorder?.eval_status === 'evaluated'
                ? ''
                : 'pointer',
          }"
        >
          <ng-container
            *ngIf="logs[0]?.workorder?.eval_status === 'unevaluated'"
          >
            评价
          </ng-container>
          <ng-container *ngIf="logs[0]?.workorder?.eval_status === 'evaluated'">
            已评价
          </ng-container>
        </button>
        <button
          class="button2"
          matRipple
          (click)="reply()"
          [disabled]="
            formGroup.invalid ||
            loading ||
            logs[0]?.workorder?.status === 'CustomerServiceCompletion' ||
            logs[0]?.workorder?.status === 'PassiveCompletion' ||
            logs[0]?.workorder?.status === 'ProactiveCompletion' ||
            logs[0]?.workorder.status === 'ProcessCompleted' ||
            logs[0]?.workorder.status === 'Completed'
          "
          [ngStyle]="{
            background:
              formGroup.invalid ||
              loading ||
              logs[0]?.workorder?.status === 'CustomerServiceCompletion' ||
              logs[0]?.workorder?.status === 'PassiveCompletion' ||
              logs[0]?.workorder?.status === 'ProactiveCompletion' ||
              logs[0]?.workorder.status === 'ProcessCompleted' ||
              logs[0]?.workorder.status === 'Completed'
                ? '#DAF2F0'
                : '#009688',
            cursor:
              formGroup.invalid ||
              loading ||
              logs[0]?.workorder?.status === 'CustomerServiceCompletion' ||
              logs[0]?.workorder?.status === 'PassiveCompletion' ||
              logs[0]?.workorder?.status === 'ProactiveCompletion' ||
              logs[0]?.workorder.status === 'ProcessCompleted' ||
              logs[0]?.workorder.status === 'Completed'
                ? ''
                : 'pointer',
          }"
        >
          提交
        </button>
      </div>
      <!-- </ng-container> -->
    </div>
  </ng-container>
</div>
